<template>
  <v-card
    v-if="robCartesIsLoading === false && relanceCreateIsLoading === false"
    flat
  >
    <dialog-relance />
    <v-card-text>
      <v-container>
        <v-row class="mb-5">
          <v-col>
            <my-progress-bar :item="nbTotal()" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="(carte, i) in robCartes" :key="i" cols="4">
            <v-card class="mb-2 radia" @dblclick="open(carte)">
              <my-card-title
                :titre="carte.prenom + ' ' + carte.nom"
                :sous-titre="carte.num + ' ' + carte.date"
                :color="color(carte)"
              />
              <v-card-text>
                <my-progress-bar :item="carte" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { generalMixin } from "@/mixins/general";
import { cardMixin } from "@/mixins/cardMixin";
import { carteMixin } from "@/mixins/carte";
import { ligneRobMixin } from "@/mixins/ligneRob";
import { commandeMixin } from "@/mixins/commande";
import { relanceMixin } from "@/mixins/relance";
import dialogRelance from "@/components/dialogRelance";

export default {
  name: "VueShowRobCarte",
  components: {
    dialogRelance,
  },
  mixins: [
    generalMixin,
    cardMixin,
    carteMixin,
    ligneRobMixin,
    commandeMixin,
    relanceMixin,
  ],
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    nbTotal() {
      let accumulator = {
        lignesRob: {
          traite: 0,
          annule: 0,
          total: 0,
        },
      };
      this.robCartes.forEach(function (carte) {
        accumulator.lignesRob.traite += carte.lignesRob.traite;
        accumulator.lignesRob.annule += carte.lignesRob.annule;
        accumulator.lignesRob.total += carte.lignesRob.total;
      });
      return accumulator;
    },
    open(carte) {
      this.affichage.rob = "tab-4";
      this.paramsRob.carteId = carte.id;
      this.breadCrumbs.carte = carte.prenom + " " + carte.nom;
      this.getligneRobs({
        robId: this.paramsRob.robId,
        carteId: carte.id,
      });
      this.getCommandes(this.paramsRob.structureId);
      this.getCommandesNoCa(this.paramsRob.structureId);
    },
  },
};
</script>

<style scoped></style>
